const reportsSearchActions = {
  REPORTS_SEARCH_INIT_STATE_SET: 'REPORTS_SEARCH_INIT_STATE_SET',
  REPORTS_SEARCH_PROP_UPDATE: 'REPORTS_SEARCH_PROP_UPDATE',
  REPORTS_SEARCH_PROP_DELETE: 'REPORTS_SEARCH_PROP_DELETE'
};
export default reportsSearchActions;
